import candidateService from '@/core/services/candidate';
import { Module } from 'vuex';
const service = new candidateService();

export interface CandidateState {}

const CandidateStore: Module<CandidateState, any> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async postCandidate(context, candidate) {
         const response = await service.postCandidate(candidate);
         return response;
      },
   },
};

export default CandidateStore;
